import { css } from '@inter-ikea-kompis/web-component';
import DividerTypeEnum from '../../enums/DividerTypeEnum.js';
/**
 * Style for Link.
 */
export default class DividerStyle {
    /**
     * Get the styles.
     *
     * @param options Options.
     * @param options.type Divider type.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { color } = options.theme;
        const borderType = options.type === DividerTypeEnum.dashed ? 'dashed' : 'solid';
        return css `
			:host {
				width: 100%;
				display: block;
				border-bottom: ${1 / 16}rem ${borderType} ${color.neutral.grey200};
			}
		`;
    }
}
//# sourceMappingURL=DividerStyle.js.map